/**
 * レイアウト関連のデザイントークン
 */
export const layout = {
  // サイドバー（左パネル）
  sidebar: {
    width: 266, // xl時の幅
    widthCollapsed: 0,
    minWidth: 240, // lg時の最小幅
    maxWidth: 260, // lg時の最大幅
  },

  // ヘッダー
  header: {
    height: 48,
    padding: '0.7rem 1rem',
  },

  // 右パネル
  rightPanel: {
    width: 272, // 全ブレークポイント共通
  },

  // 中央エリア
  mainContent: {
    maxWidth: 928, // 中央エリアの最大幅
    minWidth: 668, // lg時の最小幅
  },

  // コンテンツエリアパディング
  responsive: {
    paddingTop: '1rem',
    paddingRight: '1rem',
    paddingXs: '0.5rem', // スマホ縦: 全方向
  },

  // スペーシング
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },

  // ボーダー
  border: {
    color: '#dee2e6',
    colorLight: '#e9ecef',
    radius: 4,
    radiusLg: 8,
  },

  // HorizontalCalendar
  horizontalCalendar: {
    cellWidth: 39.5,
    cellHeight: 256,
    headerHeight: 44,
  },

  // 地図
  map: {
    height: 300,
    flexShrink: 0,
  },
} as const;

export type Layout = typeof layout;
